import styled from "styled-components";
import css from "@styled-system/css";
import { Link } from "gatsby";

export const Wrapper = styled.div`
  align-items: center;
  flex-direction: column;
  justify-content: center;
  overflow: auto;
  transition: height 500ms;

  ${({ mobileNavOpen }) =>
    css({
      display: ["flex", "flex", "none"],
      height: mobileNavOpen ? "calc(100vh - 85px)" : "0",
    })}
`;

export const NavLink = styled(Link).attrs((props) => ({
  activeClassName: "active",
}))`
  align-items: center;
  border-bottom: 5px solid;
  border-top: 5px solid;
  display: flex;
  text-decoration: none;

  ${css({
    color: "foreground.primary",
    borderColor: "border.inactive",
    fontFamily: "heading",
    fontSize: [3],
    fontWeight: "semiBold",
  })}

  &.active {
    ${css({
      borderBottomColor: "border.active",
    })}
  }
`;

export const ContactWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContactLink = styled.a`
  ${css({
    color: "foreground.primary",
  })}
`;
